<template>
  <router-view></router-view>
</template>
<script>
import { isSetting } from "./common/sbase";
// import { resetURL, setUploadURL, setURL } from "../stempcore/src/sbase";
// import URL from "./assets/conf/setting.json";
// import { URLS, $subscriber } from "fire-wind-water";
// import service from "./services/article";

// resetURL(URL);
// setUploadURL(URL.template.api.ungateway.contentUrl);
// setURL(URL.template.api.gateway.general + "/");
// window.addEventListener("message", ev => {
//   console.log("监听到postmessage的消息，如下：");
//   console.log(ev);
//   if (false === cr.isUndefined(ev.data.settingUrl))
//     $subscriber.emit("loadConfig", [ev.data]);
// });
if (!isSetting) {
  window.$sk.loading.show();
}

export default {
  name: "App",
  // mixins: [mixinsTemplate],
  data() {
    return {
      extras: {}
    };
  },
  created() {
    // this.getConfig();
  },
  mounted() {
    // console.log("# $messageLoad ...");
    // $messageLoad(1);
  },
  methods: {
    // getConfig() {
    //   const configId = URLS.getURL("configId") || "";
    //   if (configId) {
    //     let param = {
    //       configId: configId,
    //       tenantId:window.$s_temp.jsonParams.tenantId
    //     };
    //     service.getConfig(param).subscribe(data => {
    //       if (data.result == 0) {
    //         this.extras = $extras(data.content.configInfo.html[0]).extras;
    //         $subscriber.emit("loadConfig", this.extras);
    //       }
    //     });
    //   }
    // }
  }
};
</script>

<style lang="scss"></style>
